import { HierarchyType } from '@aon/tws-common-ui-hierarchy/build/lib/types';

export interface IHierarchyGroupAccess {
	hierarchyId: string;
	name: string;
	hierarchyType: HierarchyType;
	groupAccessType: GroupAccessType | null;
	employeeCount: number;
	collaboratorCount: number;
}

export enum GroupAccessType {
	AutomaticallyForManagers = 1,
	Manual = 2,
}

export default IHierarchyGroupAccess;
